// Exports the "quickbars" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/quickbars')
//   ES2015:
//     import 'tinymce/plugins/quickbars'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./static/tinymce/plugins/quickbars/index.js
// module id = T5IO
// module chunks = 3